var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGps(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 247.47,
    y: 56.61,
    style: {
      fill: "#FFAC55"
    },
    width: 17.07,
    height: 398.78
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.608,
    y: 247.463,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 255.9978 -106.0366)",
    style: {
      fill: "#FFAC55"
    },
    width: 398.776,
    height: 17.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.61,
    y: 247.47,
    style: {
      fill: "#FFAC55"
    },
    width: 398.78,
    height: 17.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.462,
    y: 56.603,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 255.9928 -106.0387)",
    style: {
      fill: "#FFAC55"
    },
    width: 17.07,
    height: 398.776
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8A3B"
    },
    d: "M256,99.556c-86.402,0-156.444,70.043-156.444,156.444S169.598,412.444,256,412.444 S412.444,342.402,412.444,256S342.402,99.556,256,99.556z M256,378.311c-67.443,0-122.311-54.868-122.311-122.311 S188.557,133.689,256,133.689S378.311,188.557,378.311,256S323.443,378.311,256,378.311z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#B9703F"
    },
    cx: 256,
    cy: 256,
    r: 42.667
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8A3B"
    },
    d: "M256,0c-8.59,0-15.555,6.964-15.555,15.555v49.588h31.11V15.555C271.555,6.964,264.59,0,256,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8A3B"
    },
    d: "M74.981,74.981c-6.075,6.075-6.075,15.923,0,21.998l35.064,35.064l21.998-21.998L96.978,74.981 C90.904,68.906,81.055,68.906,74.981,74.981z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8A3B"
    },
    d: "M0,256c0,8.591,6.964,15.555,15.555,15.555h49.588v-31.11H15.555C6.964,240.445,0,247.409,0,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8A3B"
    },
    d: "M74.981,415.022c-6.075,6.075-6.075,15.923,0,21.998s15.923,6.075,21.998,0l35.064-35.064 l-21.998-21.998L74.981,415.022z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8A3B"
    },
    d: "M240.445,496.445c0,8.591,6.964,15.555,15.555,15.555c8.59,0,15.555-6.964,15.555-15.555v-49.588 h-31.11L240.445,496.445L240.445,496.445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8A3B"
    },
    d: "M401.955,379.957l-21.998,21.998l35.064,35.064c6.075,6.075,15.923,6.075,21.998,0 s6.075-15.923,0-21.998L401.955,379.957z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8A3B"
    },
    d: "M496.445,240.445h-49.588v31.11h49.588c8.59,0,15.555-6.964,15.555-15.555 S505.036,240.445,496.445,240.445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8A3B"
    },
    d: "M415.022,74.981l-35.064,35.064l21.998,21.998l35.064-35.064c6.075-6.075,6.075-15.923,0-21.998 C430.945,68.906,421.096,68.906,415.022,74.981z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9703F"
    },
    d: "M278.597,73.676h-45.195c-4.713,0-8.533-3.82-8.533-8.533s3.821-8.533,8.533-8.533h45.195 c4.713,0,8.533,3.82,8.533,8.533S283.31,73.676,278.597,73.676z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9703F"
    },
    d: "M105.065,145.556c-2.183,0-4.368-0.833-6.034-2.499c-3.333-3.334-3.333-8.736,0-12.068 l31.957-31.958c3.333-3.331,8.736-3.331,12.067,0c3.333,3.334,3.333,8.736,0,12.068l-31.957,31.958 C109.433,144.722,107.249,145.556,105.065,145.556z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9703F"
    },
    d: "M65.142,287.131c-4.713,0-8.533-3.82-8.533-8.533v-45.196c0-4.714,3.821-8.533,8.533-8.533 c4.713,0,8.533,3.82,8.533,8.533v45.196C73.676,283.311,69.855,287.131,65.142,287.131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9703F"
    },
    d: "M137.023,415.469c-2.183,0-4.368-0.833-6.034-2.499l-31.957-31.958 c-3.333-3.334-3.333-8.736,0-12.068c3.333-3.331,8.736-3.331,12.067,0l31.957,31.958c3.333,3.334,3.333,8.736,0,12.068 C141.391,414.636,139.206,415.469,137.023,415.469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9703F"
    },
    d: "M278.597,455.391h-45.195c-4.713,0-8.533-3.82-8.533-8.533c0-4.714,3.821-8.533,8.533-8.533h45.195 c4.713,0,8.533,3.82,8.533,8.533C287.131,451.572,283.31,455.391,278.597,455.391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9703F"
    },
    d: "M374.977,415.469c-2.183,0-4.368-0.833-6.034-2.499c-3.333-3.334-3.333-8.736,0-12.068 l31.957-31.958c3.333-3.331,8.736-3.331,12.067,0c3.333,3.334,3.333,8.736,0,12.068L381.01,412.97 C379.345,414.636,377.162,415.469,374.977,415.469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9703F"
    },
    d: "M446.858,287.131c-4.713,0-8.533-3.82-8.533-8.533v-45.196c0-4.714,3.821-8.533,8.533-8.533 c4.713,0,8.533,3.82,8.533,8.533v45.196C455.391,283.311,451.57,287.131,446.858,287.131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9703F"
    },
    d: "M406.935,145.556c-2.183,0-4.368-0.833-6.034-2.499l-31.957-31.958 c-3.333-3.334-3.333-8.736,0-12.068c3.333-3.331,8.736-3.331,12.067,0l31.957,31.958c3.333,3.334,3.333,8.736,0,12.068 C411.303,144.722,409.119,145.556,406.935,145.556z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGps);
export default __webpack_public_path__ + "static/media/gps.33b789dda74c5ed2a05b0de17e2a7c34.svg";
export { ForwardRef as ReactComponent };